import React from 'react'
import API from "../Utils/api"
import MasterTemplate from "./MasterTemplate"
import { Snackbar, Slide } from "@material-ui/core";
import * as yup from 'yup';
const axios = require("axios");

const schema = yup.object().shape({
    vendaBloqueada: yup.boolean(),
    urlLiveStream: yup.string().required('Url da livestream é obrigatório.'),
    baseComissaoGerente: yup
        .number()
        .required('Comissão base do gerente é obrigatório.')
        .min(0, 'Comissão base do gerente não pode ser menor que ${min}'),
    baseComissaoCambista: yup
        .number()
        .required('Comissão base do cambista é obrigatório.')
        .min(0, 'Comissão base do cambista não pode ser menor que ${min}')
})

export class Configuracoes extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props)
        this.state = {
            errors: [],
            showErrors: false,
            user: JSON.parse(localStorage.getItem("user")),
            open: false,
            snackMessage: '',
            severity: 'info',
            comissaoGerenteCleave: null,
            parametros: {
                valorCartela: null,
                vendaBloqueada: null,
                urlLiveStream: '',
                baseComissaoGerente: null,
                baseComissaoCambista: null,
                regulamento: "",
                privateMode: false,
                contatoSAC: "",
                centralVendas: "",
                descontoCartelasApp: 0,
                modoRifa: false,
                banner: null,
                premioKuadraA: null,
                premioKuadraB: null,
                premioKinaA: null,
                premioKinaB: null,
                premioCruzA: null,
                premioCruzB: null,
                premioCheiaA: null,
                premioCheiaB: null,
                apiList: []
            },
            openModal: false,
            currentApiIndex: null,
            apiProvider: "mercadopago"
        }
        this.getPremioImagens();
        this.getBanner();
        this.alterarRegulamento = this.alterarRegulamento.bind(this)
        this.alterarPremios = this.alterarPremios.bind(this)
        this.getApiList()

    }

    async alterarRegulamento(e) {

        this.setState({ parametros: { ...this.state.parametros, regulamento: e.target.value } })
    }

    async alterarPremios(e) {

        this.setState({ parametros: { ...this.state.parametros, premios: e.target.value } })
    }

    componentDidMount() {
        this.getParametros()
    }

    getPremioImagens = async () => {
        try {
            const response = await API.get("/api/parametros/premio-imagens");
            this.setState({ parametros: { ...this.state.parametros, ...response.data } });
        } catch (error) {
            console.log(error);
        }
    }

    getParametros = async () => {
        const response = await API.get('/api/parametros')
        this.setState(state => {
            return {
                ...state,
                parametros: {
                    ...state.parametros,
                    ...response.data
                }
            }
        })
    }

    getBanner = async () => {
        const response = await API.get('/api/parametros/get-banner')
        this.setState(state => {
            return {
                ...state,
                parametros: {
                    ...state.parametros,
                    ...response.data
                }
            }
        })
    }

    getApiList = async () => {
        const response = await API.get('/api/parametros/api-list')
        this.setState(state => {
            return {
                ...state,
                parametros: {
                    ...state.parametros,
                    apiList: response.data.apiList
                }
            }
        })
    }


    updateApiList = async (newApi, apiList) => {
        if (newApi)
            apiList.push(newApi)
        const response = await API.post('/api/parametros/update-api-list', { apiList: apiList })
        this.state.parametros.apiList = apiList
        this.setState({ ...this.state })
        alert(response.data.msg)
    }

    capitalizeString(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    updateState() {

    }

    setPremioImage(e) {
        var files = e.target.files;
        if (FileReader && files && files.length) {
            const propertyName = e.target.name.split("-")[0] + this.capitalizeString(e.target.name.split("-")[1]) + e.target.name.split("-")[2].toUpperCase();
            this.setState({ parametros: { ...this.state.parametros, [propertyName]: URL.createObjectURL(files[0]) } })
            var fr = new FileReader();

            fr.onload = () => {
                window.localStorage.setItem(e.target.name, fr.result);
                this.setState({ parametros: { ...this.state.parametros, [propertyName]: fr.result } })
            }
            fr.readAsDataURL(files[0]);
        }

        // Not supported
        else {
            console.log('não suportado')
        }

    }

    setBanner(e) {
        var files = e.target.files;
        if (FileReader && files && files.length) {
            this.setState({ parametros: { ...this.state.parametros, banner: URL.createObjectURL(files[0]) } })
            var fr = new FileReader();

            fr.onload = () => {
                window.localStorage.setItem('banner-sc', fr.result);
                this.setState({ parametros: { ...this.state.parametros, banner: fr.result } })
            }
            fr.readAsDataURL(files[0]);
        }

        // Not supported
        else {
            console.log('não suportado')
        }

    }

    handleChange = event => {
        const { checked, name, value, type } = event.target
        this.setState({
            parametros: {
                ...this.state.parametros,
                [name]: type === 'checkbox' ? checked : value
            }
        })
    }

    maxComissao = value => {
        return value
    }

    handlerComissao(e) {

        if (isNaN(e.target.value)) {
            e.target.value = ""
        }
        else {
            if (e.target.value.length == 1)
                e.target.value += ".00"
            this.setState({
                parametros: {
                    ...this.state.parametros,
                    [e.target.name]: parseFloat(e.target.value).toFixed(2)
                }
            })
        }
    }

    handleSubmit = async event => {
        // event.preventDefault()

        try {
            await schema.validate(this.state.parametros, { abortEarly: false })
            var { _id, ...rest } = this.state.parametros;
            let data = await axios({
                baseURL: window.localStorage.getItem("apiUrl"),
                method: 'put',
                url: `/parametros/${_id}`,
                data: JSON.stringify(rest),
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                maxContentLength: 100000000,
                maxBodyLength: 1000000000
            })
            if (data) {
                this.setState({ open: true, showErrors: false, errors: [], severity: 'success', snackMessage: 'Informações atualizadas com sucesso.' })
                setTimeout(window.location.reload(), 3000);
            } else {
                this.setState({ open: true, showErrors: false, errors: [], severity: 'danger', snackMessage: 'Erro ao atualizar as informações.' })
            }
        } catch (err) {
            this.setState(state => {
                return {
                    ...state,
                    showErrors: true,
                    errors: err.inner
                }
            })
        }
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false })
    }

    render() {

        const formErrors = this.state.errors || null;

        return <MasterTemplate label="Configurações do sistema">
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                key={'top, center'}
                style={{ top: '60', minWidth: 420, maxWidth: 600 }}
                autoHideDuration={2800}
                TransitionComponent={Slide}
                open={this.state.open}
                onClose={this.handleClose}
            >
                <div className={`alert alert-${this.state.severity} py-3 w-100 col`} role="alert">
                    {this.state.snackMessage}
                    <button type="button" onClick={this.handleClose} className="close" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </Snackbar>

            {
                (this.state.errors.length > 0 && this.state.showErrors && (
                    <div className="alert alert-danger pb-1 pt-3 w-100 col fade show" role="alert">
                        {this.state.errors.map(item => <p key={item} style={{ fontSize: 13 }}>{item.message}</p>)}
                        <button type="button" onClick={() => this.setState({ showErrors: false })} style={{ position: 'absolute', top: '1em' }} className="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                ))
            }
            {this.state.openModal &&

                <div style={{ position: 'fixed', left: 0, top: 0, zIndex: 3000, width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: "rgba(0,0,0,0.2)" }}>
                    <div className='card' style={{ width: '96%', maxWidth: 600, }}>
                        <div className='w-100 d-flex' style={{ justifyContent: 'end' }}>
                            <button className='btn btn-light' onClick={() => { this.setState({ ...this.state, openModal: false, currentApiIndex: null }) }}>X</button>
                        </div>
                        <h2 className="card-header">
                            <div className="alert alert-dark" >
                                <b>Configurar API</b>
                            </div>
                        </h2>
                        <div className="card-body" style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                            <div className='col'>
                                <label for="api-label " className="font-weight-bold text-dark">Nome da API: </label>
                                <input id="api-label" className='form-control text-dark' placeholder='exemplo: "Mercado pago"'></input>
                                <label for="api-provider" className="font-weight-bold text-dark">Provedor: </label>
                                <select id="api-provider" className='form-control text-dark' value={this.state.apiProvider} onChange={(e) => { this.setState({ ...this.state, apiProvider: e.target.value }) }}>
                                    <option value={"mercadopago"}>Mercado Pago</option>
                                    <option value={"bankizi"}>Bankizi</option>
                                </select>
                                {this.state.apiProvider === "mercadopago" &&
                                    <>
                                        <label className="mt-2 font-weight-bold text-dark" for="api-access-token">Access Token: </label>
                                        <input id="api-access-token" className='form-control text-dark' placeholder='APP_USR-4675220881916516-101711-98703ad94ae6f61634d152cb50802ecf-2033025755'></input>
                                    </>
                                }
                                {this.state.apiProvider === "bankizi" &&
                                    <>
                                        <label className="mt-2 font-weight-bold text-dark" for="api-client-id">Client ID: </label>
                                        <input id="api-client-id" className='form-control text-dark' placeholder='APP_USR-4675220881916516-101711-98703ad94ae6f61634d152cb50802ecf-2033025755'></input>
                                        <label className="mt-2 font-weight-bold text-dark" for="api-client-secret">Client SECRET: </label>
                                        <input id="api-client-secret" className='form-control text-dark' placeholder='APP_USR-4675220881916516-101711-98703ad94ae6f61634d152cb50802ecf-2033025755'></input>
                                    </>
                                }
                                <div className='w-100 p-3' style={{ display: 'flex', justifyContent: 'end' }}>
                                    <button

                                        className="mt-2 btn btn-success btn-fill" onClick={() => {
                                            let newApi = null
                                            const label = document.getElementById("api-label") ? document.getElementById("api-label").value : null
                                            const accessToken = document.getElementById("api-access-token") ? document.getElementById("api-access-token").value : null
                                            const clientId = document.getElementById("api-client-id") ? document.getElementById("api-client-id").value : null
                                            const clientSecret = document.getElementById("api-client-secret") ? document.getElementById("api-client-secret").value : null
                                            if (label && label.length > 3) {
                                                if (this.state.currentApiIndex === this.state.parametros.apiList.length) {
                                                    newApi = {
                                                        label: label,
                                                        provider: document.getElementById("api-provider").value,
                                                        accessToken: accessToken,
                                                        clientId: clientId,
                                                        clientSecret: clientSecret,
                                                        status: 'Pending',
                                                        isActive: false
                                                    }
                                                }
                                                else {
                                                    this.state.parametros.apiList[this.state.currentApiIndex].label = label;
                                                    this.state.parametros.apiList[this.state.currentApiIndex].accessToken = accessToken;
                                                    this.state.parametros.apiList[this.state.currentApiIndex].clientId = clientId;
                                                    this.state.parametros.apiList[this.state.currentApiIndex].clientSecret = clientSecret;
                                                    this.setState({ ...this.state })
                                                }
                                                this.updateApiList(newApi, this.state.parametros.apiList)
                                            }
                                            else {
                                                alert("É necessario configurar a API corretamente!")

                                            }
                                            this.setState({ ...this.state, openModal: false, currentApiIndex: null })
                                        }}>Salvar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            }
            <div className="w-100">
                <div className="card">
                    <div className="card-body p-5">
                        <div>
                            <div class="accordion" id="first-acord" >
                                <div class="card" style={{ overflow: 'scroll', overflowY: 'hidden', display: 'flex', maxWidth: '100%', height: 170, padding: 0 }}>
                                    <h2 class="card-header" style={{margin: 0}}>
                                        <div class="alert alert-warning" style={{margin: 0}} >
                                            <b>SEGURANÇA & PRIVACIDADE</b>
                                        </div>
                                    </h2>
                                    <div id="collapse1" class="accordion-collapse collapse show" data-bs-parent="#first-acord" style={{height: 170}}>
                                        <div class="card-body w-100" style={{height: 170}} >
                                            <div className={"d-flex col w-100 justify-content-between"} style={{height: 170}}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <label className='text-secondary' htmlFor="contatoSAC" >Contato de ajuda</label>
                                                    <input style={{width: 140}} className={`form-control ${formErrors.length > 0 && formErrors.find(e => e.path === 'urlLiveStream') ? 'is-invalid' : ''}`}
                                                        id='contatoSAC'
                                                        name="contatoSAC"
                                                        type="number"
                                                        onChange={this.handleChange}
                                                        value={this.state.parametros.contatoSAC}
                                                        placeholder={this.state.parametros.contatoSAC} />
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <label className='text-secondary' htmlFor="centralVendas" >Central de vendas</label>
                                                    <input style={{width: 140}} className={`form-control ${formErrors.length > 0 && formErrors.find(e => e.path === 'urlLiveStream') ? 'is-invalid' : ''}`}
                                                        id='centralVendas'
                                                        name="centralVendas"
                                                        type="number"
                                                        onChange={this.handleChange}
                                                        value={this.state.parametros.centralVendas}
                                                        placeholder={this.state.parametros.centralVendas} />
                                                </div>
                                                <div style={{ display: "flex", width: 320, flexDirection: "column" }}>
                                                    <label className='text-secondary' htmlFor="urlLiveStream">URL transmissão</label>
                                                    <input style={{width: 220}} className={`form-control ${formErrors.length > 0 && formErrors.find(e => e.path === 'urlLiveStream') ? 'is-invalid' : ''}`}
                                                        name="urlLiveStream" type="text"
                                                        placeholder="Url da livestream"
                                                        onChange={this.handleChange}
                                                        value={this.state.parametros.urlLiveStream || ''} />
                                                </div>
                                                <div style={{ display: "flex", width: 128, flexDirection: "column" }}>
                                                    <label className='text-secondary' htmlFor="comissaoCambista">Desconto App R$</label>
                                                    <div className="d-flex align-items-center">
                                                        <input style={{width: 120}} id='teste' className="form-control text-right"
                                                            name="descontoCartelasApp"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                            value={this.state.parametros.descontoCartelasApp} />
                                                    </div>
                                                </div>

                                                <div className="form-col">
                                                    <div className="form-check d-flex align-items-center  ml-3 mt-1" style={{width: 250}}>
                                                        <label for="vendaBloqueada" className="form-check-label">
                                                            <input id='vendaBloqueada' className="form-check-input"
                                                                name="vendaBloqueada"
                                                                type="checkbox"
                                                                onChange={this.handleChange}
                                                                value={this.state.parametros.vendaBloqueada || false}
                                                                checked={this.state.parametros.vendaBloqueada || false} />
                                                            <span className="form-check-sign"></span>
                                                        </label>
                                                        <label htmlFor="vendaBloqueada" className='mb-0'>Bloquear venda de cartelas</label>
                                                    </div>

                                                    <div className="form-check d-flex align-items-center ml-3 mt-1" style={{width: 250}}>
                                                        <label for="privateMode" className="form-check-label">
                                                            <input id='privateMode' className="form-check-input"
                                                                name="privateMode"
                                                                type="checkbox"
                                                                onChange={this.handleChange}
                                                                value={this.state.parametros.privateMode || false}
                                                                checked={this.state.parametros.privateMode || false} />
                                                            <span className="form-check-sign"></span>
                                                        </label>
                                                        <label htmlFor="privateMode" className='mb-0'>Ativar modo privado</label>
                                                    </div>



                                                    <div className="form-check d-flex align-items-center  ml-3 mt-1" style={{width: 250}}>
                                                        <label className="form-check-label" htmlFor="modorifa">
                                                            <input id='modorifa' className="form-check-input"
                                                                name="modoRifa"
                                                                type="checkbox"
                                                                onChange={this.handleChange}
                                                                value={this.state.parametros.modoRifa || false}
                                                                checked={this.state.parametros.modoRifa || false} />
                                                            <span className="form-check-sign"></span>
                                                        </label>
                                                        <label className='mb-0' htmlFor="modorifa">Ativar modo rifa</label>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='card' style={{ overflow: 'scroll', overflowY: 'hidden', display: 'flex', maxWidth: '100%'}}>
                                    <div className='form-row p-2' style={{ justifyContent: 'end' }}>
                                        <button className='btn btn-primary btn-fill' onClick={() => {
                                            this.setState({ ...this.state, openModal: !this.state.openModal, currentApiIndex: this.state.parametros.apiList.length })
                                            setTimeout(() => {
                                                document.getElementById("api-label").value = '';
                                                if(window.document.getElementById("api-access-token")) window.document.getElementById("api-access-token").value = "";
                                                if(window.document.getElementById("api-client-id")) window.document.getElementById("api-client-id").value = "";
                                                if(window.document.getElementById("api-client-secret"))window.document.getElementById("api-client-secret").value = "";
                                            }, 500)

                                        }}  >Nova API</button>
                                    </div>
                                    <div className='form-row'>
                                        <table className="table table-hover table-striped">
                                            <thead>
                                                <tr>
                                                    <th>ATIVO</th>
                                                    <th>API</th>
                                                    <th>STATUS</th>
                                                    <th>TIPO</th>
                                                    <th>EDITAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.parametros.apiList.map((apiList, index) =>
                                                    <tr>
                                                        <td style={{ cursor: 'pointer' }} onClick={() => {
                                                            this.state.parametros.apiList.map((api, apiIndex) => {
                                                                this.state.parametros.apiList[apiIndex].isActive = false
                                                            })
                                                            this.state.parametros.apiList[index].isActive = true
                                                            this.updateApiList(null, this.state.parametros.apiList)
                                                        }}>{apiList.isActive ? <div className='btn btn-success btn-fill' style={{ pointerEvents: 'none', padding: 6, borderRadius: 32 }}></div> : <div style={{ pointerEvents: 'none', padding: 6, borderRadius: 32 }}></div>}</td>
                                                        <td>{apiList.label}</td>
                                                        <td>{apiList.status === "Fine" ? <div className='btn btn-info btn-fill' style={{ padding: 0, paddingLeft: 8, paddingRight: 8 }}>{apiList.status}</div> : <div className='btn btn-danger btn-fill' style={{ padding: 0, paddingLeft: 8, paddingRight: 8 }}>{apiList.status}</div>}</td>
                                                        <td>Vendas</td>
                                                        <td>
                                                            <button
                                                                className='btn btn-secodary' style={{ cursor: 'pointer', height: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', textJustify: 'inter-word', justifyItems: 'center', cursor: 'pointer', width: 32, height: 22 }}
                                                                onClick={() => {
                                                                    this.setState({ ...this.state, openModal: !this.state.openModal, currentApiIndex: index });

                                                                    setTimeout(() => {
                                                                        window.document.getElementById("api-label").value = this.state.parametros.apiList[this.state.currentApiIndex].label;
                                                                        window.document.getElementById("api-provider").value = this.state.parametros.apiList[this.state.currentApiIndex].provider;
                                                                        this.setState({...this.state, apiProvider: this.state.parametros.apiList[this.state.currentApiIndex].provider})
                                                                        if(window.document.getElementById("api-access-token"))window.document.getElementById("api-access-token").value = this.state.parametros.apiList[this.state.currentApiIndex].accessToken;
                                                                        if(window.document.getElementById("api-client-id")) window.document.getElementById("api-client-id").value = this.state.parametros.apiList[this.state.currentApiIndex].clientId;
                                                                        if(window.document.getElementById("api-client-secret"))window.document.getElementById("api-client-secret").value = this.state.parametros.apiList[this.state.currentApiIndex].clientSecret;
                                                                    }, 500)
                                                                }}
                                                            >• • •</button>
                                                        </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>


                                <div class="card">
                                    <h2 class="card-header">
                                        <div class="alert alert-primary" >
                                            <b>BANNER E IMAGENS DE PREMIOS</b>
                                        </div>
                                    </h2>
                                    <div id="collapse2" class="accordion-collapse collapse show" data-bs-parent="#first-acord">
                                        <div class="card-body">
                                            <div className="form-row styled-input mt-5">
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>CLIQUE NO BANNER PARA ALTERAR</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="banner-input-tag">
                                                            <img

                                                                className="preview-image"
                                                                width="256"
                                                                height="256"
                                                                src={this.state.parametros.banner}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="banner-input-tag"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"

                                                            onChange={this.setBanner.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                            </div>

                                            <h5 className='mt-5 text-muted font-weight-bold'>EXIBIÇÃO DA QUADRA</h5>
                                            <span className='mt-1 text-muted' >Dica* : usar imagens de baixa resolução no formato webp para melhor desempenho durante o sorteio.</span>
                                            <hr />
                                            <div className="form-row styled-input mt-1">
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>ANTES</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-kuadra-a">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioKuadraA}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-kuadra-a"
                                                            name="premio-kuadra-a"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                                <div className='col align-items-center justify-content-center'><div className='mt-5'><h3 className='text-muted font-weight-bold'>⇨</h3></div></div>
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>DEPOIS</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-kuadra-b">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioKuadraB}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-kuadra-b"
                                                            name="premio-kuadra-b"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                            </div>


                                            <h5 className='mt-5 text-muted font-weight-bold'>EXIBIÇÃO DA KINA</h5>
                                            <span className='mt-1 text-muted' >Dica* : usar imagens de baixa resolução no formato webp para melhor desempenho durante o sorteio.</span>
                                            <hr />
                                            <div className="form-row styled-input mt-1">
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>ANTES</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-kina-a">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioKinaA}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-kina-a"
                                                            name="premio-kina-a"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                                <div className='col align-items-center justify-content-center'><div className='mt-5'><h3 className='text-muted font-weight-bold'>⇨</h3></div></div>
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>DEPOIS</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-kina-b">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioKinaB}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-kina-b"
                                                            name="premio-kina-b"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                            </div>


                                            <h5 className='mt-5 text-muted font-weight-bold'>EXIBIÇÃO DA CRUZADINHA</h5>
                                            <span className='mt-1 text-muted' >Dica* : usar imagens de baixa resolução no formato webp para melhor desempenho durante o sorteio.</span>
                                            <hr />
                                            <div className="form-row styled-input mt-1">
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>ANTES</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-cruz-a">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioCruzA}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-cruz-a"
                                                            name="premio-cruz-a"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                                <div className='col align-items-center justify-content-center'><div className='mt-5'><h3 className='text-muted font-weight-bold'>⇨</h3></div></div>
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>DEPOIS</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-cruz-b">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioCruzB}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-cruz-b"
                                                            name="premio-cruz-b"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                            </div>


                                            <h5 className='mt-5 text-muted font-weight-bold'>EXIBIÇÃO DA CHEIA </h5>
                                            <span className='mt-1 text-muted' >Dica* : usar imagens de baixa resolução no formato webp para melhor desempenho durante o sorteio.</span>
                                            <hr />
                                            <div className="form-row styled-input mt-1">
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>ANTES</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-cheia-a">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioCheiaA}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-cheia-a"
                                                            name="premio-cheia-a"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                                <div className='col align-items-center justify-content-center'><div className='mt-5'><h3 className='text-muted font-weight-bold'>⇨</h3></div></div>
                                                <div className='col'>
                                                    <span className='text-muted font-weight-bold'>DEPOIS</span>
                                                    <div className="mt-1 d-flex align-items-center input-container">
                                                        <label for="premio-cheia-b">
                                                            <img

                                                                className="preview-image"
                                                                width="200"
                                                                height="200"
                                                                src={this.state.parametros.premioCheiaB}
                                                                alt="Preview"
                                                            />
                                                        </label>
                                                        <input
                                                            id="premio-cheia-b"
                                                            name="premio-cheia-b"
                                                            className="form-control file-input invisible"
                                                            accept="image/*"
                                                            type="file"
                                                            onChange={this.setPremioImage.bind(this)}
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>






                            <div className="form-col mt-5">
                                <h5 className='text-secondary'>EXIBIÇÃO DA TABELA DE PRÊMIOS</h5>
                                <div className="form-check d-flex align-items-center">

                                    <textarea onChange={this.alterarPremios} value={this.state.parametros.premios} name="message" rows="10" cols="100" />

                                </div>
                            </div>

                            <div className="form-col mt-5">
                                <h5 className='text-secondary'>DOCUMENTO DE TEXTO DO REGULAMENTO</h5>
                                <div className="form-check d-flex align-items-center">

                                    <textarea onChange={this.alterarRegulamento} value={this.state.parametros.regulamento} name="message" rows="10" cols="100" />

                                </div>
                            </div>

                            <div className="form-row">
                                <div className="col col-12">
                                    <button className="btn btn-success btn-fill float-right" onClick={() => { this.handleSubmit() }}>Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </MasterTemplate>;
    }
}

export default Configuracoes
